import { useId, useState } from "react";
import { CoreButton } from "../button/Button";
import styles from "./CoreUpload.module.css";
import DragAndDropIcon from "./images/drag-and-drop.svg?react";

type CoreUploadProps = {
	description: string;
	buttonText: string;
	onUpload: (file: File) => void;
	fileTypes: string;
	className?: string;
};

export default function CoreUpload({ description, buttonText, onUpload, fileTypes, className }: CoreUploadProps) {
	const [isDragActive, setIsDragActive] = useState(false);
	const fileInputId = useId();
	return (
		<div
			className={`${styles.uploadContainer} ${isDragActive ? styles.dragActive : ""} ${className ?? ""}`}
			onDrop={(event: React.DragEvent) => {
				event.preventDefault();
				setIsDragActive(false);
				const file = event.dataTransfer.files[0];
				onUpload(file);
			}}
			onDragOver={(e) => e.preventDefault()}
			onDragEnter={() => setIsDragActive(true)}
			onDragLeave={() => setIsDragActive(false)}
		>
			<DragAndDropIcon />
			<div className={styles.dragAndDropText}>{description}</div>
			<CoreButton
				onClick={() => {
					document.getElementById(fileInputId)?.click();
				}}
			>
				<input
					hidden
					id={fileInputId}
					accept={fileTypes}
					type="file"
					onChange={(e) => {
						const file = e.target.files?.[0];
						if (file) onUpload(file);
					}}
				/>
				{buttonText}
			</CoreButton>
		</div>
	);
}
